import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
    selector: 'app-super-star',
    templateUrl: './super-star.component.html',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SuperStarComponent
{

}
